module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("经办人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.userPeopleName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.applyDate))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("经办部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.userDepartName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("职务")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.jibie))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("报销信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("费用名称"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("单据编号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.recCode))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("是否用于抵扣费用报销（不计入成本）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('inline-x-switch', {
    on: {
      "on-change": _vm.switchVal
    },
    model: {
      value: (_vm.isDeduction),
      callback: function($$v) {
        _vm.isDeduction = $$v
      },
      expression: "isDeduction"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("责任中心")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.checkDeptResultName) + "\n        ")]), _vm._v(" "), _c('td', [_c('x-button', {
    staticClass: "inline-btn",
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.openDialog('deptTree')
      }
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('x-button', {
    staticClass: "inline-btn",
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearDeptResult($event)
      }
    }
  }, [_vm._v("清除")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("所属业务")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.businessChoosed.businessName) + "\n        ")]), _vm._v(" "), _c('td', [_c('x-button', {
    staticClass: "inline-btn",
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.openDialog('business')
      }
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('x-button', {
    staticClass: "inline-btn",
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {}
    }
  }, [_vm._v("清除")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("报销明细")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-button', {
    staticClass: "inline-btn",
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.openDialog('expense')
      }
    }
  }, [_vm._v(_vm._s(_vm.btnText))])], 1)])])]), _vm._v(" "), _c('x-table', {
    staticClass: "expense-detail"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("费用类型及说明")]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("报销费用")]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("计入部门考核")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.savedList.feeRemark))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.savedList.money10))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.savedList.falDepAudit))])])])]), _vm._v(" "), _c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("费用合计(元)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total1))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("费用合计大写（元）")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total2))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("单据附件")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('input', {
    staticClass: "inputfile",
    attrs: {
      "type": "file",
      "name": "file",
      "id": "file",
      "accept": "image/*",
      "multiple": ""
    },
    on: {
      "change": _vm.chooseFile
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "btn-file",
    attrs: {
      "for": "file"
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "box"
    }
  }), _vm._l((_vm.fileShowList), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "img-box"
    }, [_c('img', {
      staticClass: "icon-close",
      attrs: {
        "src": require("../../../assets/icon/close-blue.png")
      },
      on: {
        "click": function($event) {
          _vm.deleteFile(key)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "img-part",
      attrs: {
        "src": item,
        "alt": ""
      }
    })])
  }), _vm._v(" "), _c('p')], 2)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("借款抵消")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-button', {
    staticClass: "inline-btn",
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.openDialog('jkdx')
      }
    }
  }, [_vm._v("增加")]), _vm._v(" "), (_vm.businessOffsetListRadio.length > 0) ? _c('x-button', {
    staticClass: "inline-btn",
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.businessJKDXDelete($event)
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('x-table', {
    staticClass: "loan-offset",
    attrs: {
      "id": "offset-list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name",
    attrs: {
      "id": "offset-first-td"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请人")]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("业务名称")]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("剩余可抵扣金额")]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("本次抵扣金额")])]), _vm._v(" "), _vm._l((_vm.businessOffsetListRadio), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.businessOffsetRadioVal),
        expression: "businessOffsetRadioVal"
      }],
      attrs: {
        "type": "radio",
        "name": ""
      },
      domProps: {
        "value": key,
        "checked": _vm._q(_vm.businessOffsetRadioVal, key)
      },
      on: {
        "change": function($event) {
          _vm.businessOffsetRadioVal = key
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.applyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.businessName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.loanMoney - item.totalDeductible))]), _vm._v(" "), _c('td', [_c('x-input', {
      ref: 'deductMoney' + key,
      refInFor: true,
      attrs: {
        "title": "",
        "placeholder": "请输入"
      },
      on: {
        "on-blur": function($event) {
          _vm.getDeductMoney(key)
        }
      },
      model: {
        value: (_vm.deductMoney),
        callback: function($$v) {
          _vm.deductMoney = $$v
        },
        expression: "deductMoney"
      }
    })], 1)])
  }), _vm._v(" "), _c('tr')], 2)]), _vm._v(" "), _c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("抵消借款（元）")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.savedJKDXObj.loanTotal))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("应付金额")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shouldPayShow))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("部门未归还借款")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.departLoanMoney) + "," + _vm._s(_vm.applicantLoanMoney))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("收款人信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("收款人/单位")]), _vm._v(" "), _c('td', [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.payUnitName),
      callback: function($$v) {
        _vm.payUnitName = $$v
      },
      expression: "payUnitName"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("收款银行")]), _vm._v(" "), _c('td', [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.bank),
      callback: function($$v) {
        _vm.bank = $$v
      },
      expression: "bank"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("收款账号")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.bankAccount),
      callback: function($$v) {
        _vm.bankAccount = $$v
      },
      expression: "bankAccount"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("备注")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('x-textarea', {
    attrs: {
      "max": 100,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('x-dialog', {
    staticClass: "dialog-part",
    model: {
      value: (_vm.showToast),
      callback: function($$v) {
        _vm.showToast = $$v
      },
      expression: "showToast"
    }
  }, [_c('div', {
    staticClass: "dialog-close-btn",
    on: {
      "click": function($event) {
        _vm.showToast = false
      }
    }
  }, [_c('span', [_c('img', {
    staticStyle: {
      "padding": "8px 10px 0px 0px"
    },
    attrs: {
      "slot": "label",
      "src": require("../../../assets/icon/close.png"),
      "width": "24",
      "height": "24"
    },
    slot: "label"
  })])]), _vm._v(" "), (_vm.checkTreeShow) ? _c('div', {
    attrs: {
      "id": "dept-part"
    }
  }, [_c('group', {
    attrs: {
      "id": "searchBar"
    }
  }, [_c('x-input', {
    attrs: {
      "title": "搜索",
      "placeholder": "在此输入部门"
    },
    on: {
      "on-click-clear-icon": _vm.clearSearchResult
    },
    model: {
      value: (_vm.checkTreeSearchVal),
      callback: function($$v) {
        _vm.checkTreeSearchVal = $$v
      },
      expression: "checkTreeSearchVal"
    }
  }, [_c('x-button', {
    attrs: {
      "slot": "right",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.treeSearch($event)
      }
    },
    slot: "right"
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "searchResult"
    }
  }, [_c('ul', _vm._l((_vm.checkTreeSearchResult), function(item) {
    return _c('li', [_c('span', [_c('x-button', {
      nativeOn: {
        "click": function($event) {
          _vm.addToTree(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])], 1)])
  }))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "dept-tree-part"
    }
  }, [_c('el-tree', {
    ref: "tree",
    attrs: {
      "id": "checkType",
      "data": _vm.treeData,
      "props": _vm.treeProps,
      "node-key": "id",
      "show-checkbox": ""
    },
    on: {
      "check-change": _vm.getCheckedNodes
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.businessShow) ? _c('div', {
    attrs: {
      "id": "business-part"
    }
  }, [_c('div', [_c('div', {
    staticClass: "dialog-input"
  }, [_c('p', [_c('x-input', {
    attrs: {
      "id": "businessName",
      "title": "业务名称",
      "placeholder": "    请输入",
      "show-clear": true
    },
    model: {
      value: (_vm.businessName),
      callback: function($$v) {
        _vm.businessName = $$v
      },
      expression: "businessName"
    }
  }, [_c('x-button', {
    staticClass: "dialog-btn",
    attrs: {
      "slot": "right",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.searchBusiness($event)
      }
    },
    slot: "right"
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('p', [_c('group', [_c('selector', {
    attrs: {
      "value-map": ['name', 'name'],
      "title": "业务类型",
      "options": _vm.selectorList
    },
    model: {
      value: (_vm.selectorValue),
      callback: function($$v) {
        _vm.selectorValue = $$v
      },
      expression: "selectorValue"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-part"
  }, [(this.businessList.length > 0) ? _c('x-table', {
    staticStyle: {
      "background-color": "#fff",
      "width": "100%"
    },
    attrs: {
      "full-bordered": ""
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "dialog-title-tr"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("业务名称")]), _vm._v(" "), _c('td', [_vm._v("委托单位")]), _vm._v(" "), _c('td', [_vm._v("项目经理")]), _vm._v(" "), _c('td', [_vm._v("业务类型")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.businessList), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', {
      staticClass: "dialog-switch-td"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.businessChoosed),
        expression: "businessChoosed"
      }],
      attrs: {
        "type": "radio",
        "name": "abc"
      },
      domProps: {
        "value": item,
        "checked": _vm._q(_vm.businessChoosed, item)
      },
      on: {
        "change": function($event) {
          _vm.businessChoosed = item
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.businessName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.consignorUnitNames))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.managerName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.flowType))])])
  }))]) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "dialog-bottom-bar"
  }, [(this.businessList.length > 0) ? _c('span', [_c('x-button', {
    staticClass: "dialog-btn btn-prev",
    attrs: {
      "mini": "",
      "disabled": _vm.preStatus
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getPrePage($event)
      }
    }
  }, [_vm._v("上一页")]), _vm._v("\n              " + _vm._s(_vm.pageNum) + "/" + _vm._s(_vm.businessAllNum) + "页\n              "), _c('x-button', {
    staticClass: "dialog-btn btn-next",
    attrs: {
      "mini": "",
      "disabled": _vm.nextStatus
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getNextPage($event)
      }
    }
  }, [_vm._v("下一页")])], 1) : _vm._e(), _vm._v(" "), _c('x-button', {
    staticClass: "dialog-btn btn-confirm",
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.chooseBusiness($event)
      }
    }
  }, [_vm._v("确定")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.expenseShow) ? _c('div', {
    attrs: {
      "id": "expense-detail-part"
    }
  }, [_c('div', [_vm._v("报销明细")]), _vm._v(" "), _c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("费用类型及说明")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.feeRemark),
      callback: function($$v) {
        _vm.feeRemark = $$v
      },
      expression: "feeRemark"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("报销费用")]), _vm._v(" "), _c('td', [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    on: {
      "on-blur": _vm.changeMoney11
    },
    model: {
      value: (_vm.money10),
      callback: function($$v) {
        _vm.money10 = $$v
      },
      expression: "money10"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("财务核实金额列")]), _vm._v(" "), _c('td', [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.money11),
      callback: function($$v) {
        _vm.money11 = $$v
      },
      expression: "money11"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("成本科目")]), _vm._v(" "), _c('td', {
    staticClass: "select-td"
  }, [_c('group', [_c('selector', {
    staticClass: "select-gp",
    attrs: {
      "value-map": ['FSN', 'FName'],
      "title": "",
      "options": _vm.expenseCostItemsList
    },
    model: {
      value: (_vm.expenseCostItemsVal),
      callback: function($$v) {
        _vm.expenseCostItemsVal = $$v
      },
      expression: "expenseCostItemsVal"
    }
  })], 1)], 1), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("成本类型")]), _vm._v(" "), _c('td', {
    staticClass: "select-td"
  }, [_c('group', [_c('selector', {
    staticClass: "select-gp",
    attrs: {
      "value-map": ['FSN', 'FName'],
      "title": "",
      "options": _vm.expenseCostTypeList
    },
    model: {
      value: (_vm.expenseCostTypeVal),
      callback: function($$v) {
        _vm.expenseCostTypeVal = $$v
      },
      expression: "expenseCostTypeVal"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("是否电子发票")]), _vm._v(" "), _c('td', [_c('inline-x-switch', {
    on: {
      "on-change": _vm.switchEInvoice
    },
    model: {
      value: (_vm.isEInvoice),
      callback: function($$v) {
        _vm.isEInvoice = $$v
      },
      expression: "isEInvoice"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("发票号码")]), _vm._v(" "), _c('td', [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.eleInvoiceNo),
      callback: function($$v) {
        _vm.eleInvoiceNo = $$v
      },
      expression: "eleInvoiceNo"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("计入部门考核")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('inline-x-switch', {
    on: {
      "on-change": _vm.switchFalDepAudit
    },
    model: {
      value: (_vm.falDepAudit),
      callback: function($$v) {
        _vm.falDepAudit = $$v
      },
      expression: "falDepAudit"
    }
  })], 1)])])]), _vm._v(" "), _c('div', [_c('x-button', {
    staticClass: "dialog-btn expense-btn",
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.expenseSave($event)
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), (_vm.btnText == '修改') ? _c('x-button', {
    staticClass: "dialog-btn expense-btn",
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.expenseDelete($event)
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.saveMoneyJKDXShow) ? _c('div', {
    attrs: {
      "id": "save-money-jkdx"
    }
  }, [_c('div', [_vm._v("借款单")]), _vm._v(" "), _c('x-table', [_c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("申请人")]), _vm._v(" "), _c('td', [_vm._v("业务名称")]), _vm._v(" "), _c('td', [_vm._v("剩余可抵扣金额")])]), _vm._v(" "), _vm._l((_vm.loanList), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.businessJKDXChoosed),
        expression: "businessJKDXChoosed"
      }],
      attrs: {
        "type": "radio",
        "name": ""
      },
      domProps: {
        "value": item,
        "checked": _vm._q(_vm.businessJKDXChoosed, item)
      },
      on: {
        "change": function($event) {
          _vm.businessJKDXChoosed = item
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.applicantName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.businessName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.surplusDeductible))])])
  })], 2)]), _vm._v(" "), _c('div', [_c('x-button', {
    staticClass: "dialog-btn expense-btn",
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.businessJKDXSave($event)
      }
    }
  }, [_vm._v("确定")])], 1)], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-622b815c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/launch/finance/costExpense.vue
// module id = iWQ+
// module chunks = 1